import { SocketMessageType, useSocketEvent } from '@aibees/shared/socket';
import { useGetSocketChannel } from '@aibees/shared/socket/hooks/use-get-socket-channel';
import { CreditsSocketMessage, OnReceiveSocketCreditEvent } from './types';

export function useCreditUpdateSocketListener(
  onEvent: OnReceiveSocketCreditEvent
) {
  const channel = useGetSocketChannel(SocketMessageType.BALANCE);

  useSocketEvent(channel, (data: CreditsSocketMessage) => {
    if (data.type === SocketMessageType.BALANCE) {
      onEvent(data);
    }
  });
}
